module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "chap1"
    }
  }, [_vm._v("INTRODUCTION")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THEN TENDERED ON")]), _vm._v(" explanation spontaneous and unsolicited concerning my own work, affording an insight as to its aesthetic, its daemon, its argument, its sorrow and its joy, its darkness, its sun-twinkle clearness.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Flann O’Brien")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f949784","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/5-chap1.vue
// module id = 72
// module chunks = 0